import React from 'react';
import sIcon1 from '../../images/icon/eye-icon.svg'
import sIcon2 from '../../images/feature/ap-feature01.png'
import sIcon3 from '../../images/feature/ap-feature02.png'
import sIcon4 from '../../images/feature/ap-feature03.png'


const WhyChoose = (props) => {

    return (
        <section className="feature pt-130">
                <div className="container">
                    <div className="sec-title--two text-center mb-60">
                        <div className="sub-title"><img src={sIcon1} alt=""/> Why choose us</div>
                        <h2 className="title">Why TechStr?</h2>
                    </div>
                    <div className="row mt-none-30">
                        <div className="col-lg-4 col-md-6 mt-30">
                            <div className="ap-fea-item pos-rel">
                                <div className="xb-item--img"><img src={sIcon2} alt=""/></div>
                                <h3 className="xb-item--content">Highly skilled and accredited team.</h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mt-30">
                            <div className="ap-fea-item pos-rel">
                                <div className="xb-item--img"><img src={sIcon3} alt=""/></div>
                                <h3 className="xb-item--content">Flexible solutions to match business size and budget.</h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mt-30">
                            <div className="ap-fea-item pos-rel">
                                <div className="xb-item--img"><img src={sIcon4} alt=""/></div>
                                <h3 className="xb-item--content">Focus on automation, AI-driven workflows, and emerging technologies.</h3>
                            </div>
                        </div>
                    </div>
                </div>
             </section>
    );
}

export default WhyChoose;